import { deprecate } from './console'

export * from '../components/Vuetify/goTo/easing-patterns'

deprecate('vuetify/es5/util/easing-patterns', 'vuetify/es5/Vuetify/goTo/easing-patterns')
